import { render, staticRenderFns } from "./ocrRecognitionAE.vue?vue&type=template&id=2a3567fe&scoped=true&"
import script from "./ocrRecognitionAE.vue?vue&type=script&lang=js&"
export * from "./ocrRecognitionAE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3567fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3567fe')) {
      api.createRecord('2a3567fe', component.options)
    } else {
      api.reload('2a3567fe', component.options)
    }
    module.hot.accept("./ocrRecognitionAE.vue?vue&type=template&id=2a3567fe&scoped=true&", function () {
      api.rerender('2a3567fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocrRecognitionAE.vue"
export default component.exports